import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchNews = createAsyncThunk('newsSlice/fetchNews', async () => {
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?news_website`)
    const data = await res.json()
    return data;
})

const newsSlice = createSlice({
    initialState: {
        news: [],
        loading: false,
        error: null,
    },
    name: 'newsSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchNews.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchNews.fulfilled, (state, action) => {
                state.loading = false;
                state.news = action.payload;
            })
            .addCase(fetchNews.rejected, (state, action) => {
                state.loading = false;
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

export const { } = newsSlice.actions;

export default newsSlice.reducer;